export default "/images/vendor/flag-icons/flags/4x3/nz.svg?64b16b7eb8b8e423bcabb80c594018ad";